import { ICalendarDoor, ICalendarDoorProduct } from '@/common/interfaces/announcement-bar.interface';
import {
  IApiCalendarDoor,
  IApiCalendarDoorProduct,
  IApiGiveawayRegistrationFormData,
} from '@/common/interfaces/api.interface';
import { INewsletterFormData } from '@/common/interfaces/frontpage.interface';

export default class AnnouncementBarHelper {
  public static transformApiCalendarDoorProductToCalendarDoorProduct(product: IApiCalendarDoorProduct): ICalendarDoorProduct {
    return {
      description: product.description,
      link: product.link,
      matchcode: product.matchcode,
      name: product.name,
      prices: product.prices,
    };
  }

  public static transformApiCalendarDoorProductsToCalendarDoorProducts(products: IApiCalendarDoorProduct[]): ICalendarDoorProduct[] {
    return products.map(product => this.transformApiCalendarDoorProductToCalendarDoorProduct(product));
  }

  public static transformApiCalendarDoorToCalendarDoor(door: IApiCalendarDoor): ICalendarDoor {
    return {
      calendarId: door.calendarId,
      id: door.id,
      imageLink: door.imageLink,
      link: door.link ?? ``,
      locizeIdentifier: door.locizeIdentifier,
      products: door.products ? this.transformApiCalendarDoorProductsToCalendarDoorProducts(door.products) : undefined,
      type: door.type,
    };
  }

  public static transformGiveawayFormDataToApiGiveawayRegistrationFormData(data: INewsletterFormData, calendarId: number, doorId: number): IApiGiveawayRegistrationFormData {
    return {
      action: `anmelden`,
      calendarId,
      clientIP: ``,
      doorId,
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      salutationId: data.gender,
    };
  }
}
